import React  from "react";

/**
 * Custom hook che integra il Facebook Pixel nella pagina corrente.
 *
 * Al primo utilizzo carica dinamicamente lo script ufficiale del Pixel e,
 * se disponibile un identificativo valido, inizializza `fbq` con il valore
 * letto da `REACT_APP_FACEBOOK_PIXEL_ID`.
 *
 * A ogni esecuzione dell'effetto invia quindi l'evento standard `PageView`,
 * cosi da tracciare la visualizzazione della pagina in cui l'hook viene usato.
 */
function useFacebookPixelPageView() {

    const pixelId = process.env.REACT_APP_FACEBOOK_PIXEL_ID;

    React.useEffect(() => {

        if(!pixelId) {
            return;
        }

        if (!window.fbq) {

            (function (f, b, e, v, n, t, s) {
                if (f.fbq) return;
                n = f.fbq = function () {
                    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
                };
                if (!f._fbq) f._fbq = n;
                n.push = n;
                n.loaded = !0;
                n.version = "2.0";
                n.queue = [];
                t = b.createElement(e);
                t.async = !0;
                t.src = v;
                s = b.getElementsByTagName(e)[0];
                s.parentNode.insertBefore(t, s);
            })(
                window,
                document,
                "script",
                "https://connect.facebook.net/en_US/fbevents.js"
            );

            window.fbq("init", pixelId);
        }

        window.fbq("track", "PageView");

    }, [pixelId]);
}

export default useFacebookPixelPageView;
